sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var ProjectCalendar = BlockBase.extend("com.reply.leaviosa.blocks.calendar.ProjectCalendar", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.calendar.ProjectCalendar",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.calendar.ProjectCalendar",
					type: ViewType.XML
				}
			}
		}
	});

	return ProjectCalendar;
});